/**
 * Detects if the current device is iOS
 */
export const isIOS = (): boolean => {
  if (typeof window === "undefined") return false;
  
  // Check user agent for iOS devices
  if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
    return true;
  }
  
  // Check for iPad on iOS 13+ (which reports as MacIntel)
  // Use maxTouchPoints as a reliable indicator
  if (navigator.maxTouchPoints > 1 && /Mac/.test(navigator.userAgent)) {
    return true;
  }
  
  return false;
};

/**
 * Detects if the current device is Android
 */
export const isAndroid = (): boolean => {
  if (typeof window === "undefined") return false;
  
  return /Android/.test(navigator.userAgent);
};
